import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { Button as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Send } from '../../images/icons/pubblica.svg';

interface IProps extends StyledComponentProps {
    onClick: (evt: any) => any;
    disabled?: boolean;
    text: string;
}

const SendButton = React.forwardRef((props: IProps, ref: any) => {
    return <MuiButton
        innerRef={ref}
        disabled={props.disabled}
        className={props.classes.btnRootWithIcon}
        onClick={props.onClick}
        variant="contained">
        <div className={props.classes.withLeftIcon}>
            <Send className={props.classes.buttonItemIcon} />
            {props.text}
        </div>
    </MuiButton>
});

// const SendButton = (props: IProps) => {
//     return (<MuiButton
//         disabled={props.disabled}
//         className={props.classes.btnRootWithIcon}
//         onClick={props.onClick}
//         variant="contained">
//         <div className={props.classes.withLeftIcon}>
//             <Send className={props.classes.buttonItemIcon} />
//             {props.text}
//         </div>
//     </MuiButton>)
// }


export default withStyles(styles)(SendButton)